import { render, staticRenderFns } from "./wdtOrderList.vue?vue&type=template&id=48ccc8fe&scoped=true"
import script from "./wdtOrderList.vue?vue&type=script&lang=js"
export * from "./wdtOrderList.vue?vue&type=script&lang=js"
import style0 from "./wdtOrderList.vue?vue&type=style&index=0&id=48ccc8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ccc8fe",
  null
  
)

export default component.exports